// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios';
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import seal from "../common/uni-seal.js";
import Viewer from 'v-viewer' //放大预览图片
import 'viewerjs/dist/viewer.css'
import 'lib-flexible'


Vue.use(Viewer)
import {
  Message
} from 'element-ui';

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$Message = Message; // 将 Axios 实例挂载到 Vue 原型上
Vue.prototype.$Seal = seal; // 将 Axios 实例挂载到 Vue 原型上


// 创建一个全局的 Axios 实例
const axiosInstance = axios.create({
  baseURL: 'https://pen.loojj.com/' // 设置接口前缀
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理，例如添加请求头等
    // config.headers['Authorization'] = 'Bearer your_token';
    return config;
  },
  error => {
    // 处理请求错误
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  response => {
    // 在接收到响应数据之前做一些处理
    switch (response.data.code) {
      case 200:
        return response.data;
        break;
      case 0:
        Message.error(response.data.msg);
        break;
    }
  },
  error => {
    // 处理响应错误
    return Promise.reject(error);
  }
);
Vue.prototype.$http = axiosInstance; // 将 Axios 实例挂载到 Vue 原型上


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js